import { game } from '../main';

export function createOneLineText(
  x: number,
  y: number,
  font: string,
  text: string,
  size: number,
  width: number,
  hAnchor: number,
  vAnchor: number,
  skipArabic: boolean = false,
): Phaser.Text | OneLineText {
  if (!skipArabic && game.lang === 'ar') {
    const textObject = game.make.text(x, y, text, {
      fontSize: size,
      fill: 'white'
    });
    textObject.anchor.setTo(hAnchor, vAnchor);

    if (width) {
      textObject.width = Math.min(width, textObject.width);
    }

    return textObject;
  };

  return new OneLineText(x, y, font, text, size, width, hAnchor, vAnchor);
}



export class OneLineText extends Phaser.Text {
  private orgFontSize: number;
  private maxUserWidth: number;
  private skipCaching: boolean;

  constructor(
    x: number,
    y: number,
    font: string,
    text: string,
    size: number,
    width: number,
    hAnchor: number,
    vAnchor: number,
  ) {
    super(game, x, y, text, {
      fontSize: size,
      fill: 'white',
      font: 'Comfortaa',
    });

    this.setShadow(2, 2, 'black', 0, false, true);

    if (width) {
      while (this.width > width) {
        this.fontSize -= 2;
        this.updateText();
        if (this.fontSize < 5) break;
      }
    }

    this.orgFontSize = size;
    this.maxUserWidth = width;


    this.skipCaching = false;

    this.anchor.setTo(hAnchor, vAnchor);
    this.updateText();
  }

  public setText(text: string): void {
    Phaser.Text.prototype.setText.call(this, text.toString());

    const oldScaleX = this.scale.x;
    const oldScaleY = this.scale.y;
    const oldAlpha = this.alpha;
    const oldAngle = this.angle;

    this.alpha = 1;
    this.scale.set(1, 1);


    if (this.maxUserWidth) {
      this.fontSize = this.orgFontSize;
      this.updateText();
      while (this.width > this.maxUserWidth) {
        this.fontSize -= 1;

        this.updateText();
        if (this.fontSize < 5) break;
      }
    }

    this.scale.set(oldScaleX, oldScaleY);
    this.alpha = oldAlpha;
    this.angle = oldAngle;
    //this._cachedSprite.anchor.setTo(this.hAnchor || 0.5,1);
  }
}


